import { StateToken } from '@ngxs/store';

import { PROJECT_FEATURE_KEY } from '../../constants';
import { Project } from '../../models';

export interface ProjectStateModel {
  current: Project;
}

export const PROJECT_STATE_TOKEN = new StateToken<ProjectStateModel>(PROJECT_FEATURE_KEY);
